var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgrammer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 6C16 8.20914 14.2091 10 12 10C9.79086 10 8 8.20914 8 6C8 3.79086 9.79086 2 12 2C14.2091 2 16 3.79086 16 6Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 14C4 12.8954 4.89543 12 6 12H18C19.1046 12 20 12.8954 20 14C20 18.4183 16.4183 22 12 22C7.58172 22 4 18.4183 4 14ZM13.4888 14.1779C13.587 13.7755 13.3403 13.3697 12.9379 13.2715C12.5355 13.1734 12.1297 13.42 12.0316 13.8224L10.7714 18.9891C10.6732 19.3915 10.9199 19.7973 11.3223 19.8955C11.7247 19.9936 12.1305 19.747 12.2286 19.3446L13.4888 14.1779ZM9.89683 14.5274C10.1881 14.2328 10.1854 13.758 9.8908 13.4667C9.59624 13.1755 9.12138 13.1782 8.83015 13.4728L6.65972 15.668C6.11343 16.2206 6.11343 17.1129 6.65972 17.6655L8.83015 19.8607C9.12138 20.1553 9.59624 20.158 9.8908 19.8668C10.1854 19.5755 10.1881 19.1007 9.89683 18.8061L7.78166 16.6667L9.89683 14.5274ZM15.1698 13.4728C14.8786 13.1782 14.4038 13.1755 14.1092 13.4667C13.8146 13.758 13.8119 14.2328 14.1032 14.5274L16.2183 16.6667L14.1032 18.8061C13.8119 19.1007 13.8146 19.5755 14.1092 19.8668C14.4038 20.158 14.8786 20.1553 15.1698 19.8607L17.3403 17.6655C17.8866 17.1129 17.8866 16.2206 17.3403 15.668L15.1698 13.4728Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgrammer);
export default __webpack_public_path__ + "static/media/programmer.280d4c86e680fe1bff0b7c4c035ca163.svg";
export { ForwardRef as ReactComponent };